import React from 'react';
import classNames from 'classnames';

import StatusBox from 'components/StatusBox';
import ExternalLink from 'components/ExternalLink';

import removeButton from './assets/e-remove.svg';
import inviteButton from './assets/web-hyperlink.svg';
import './styles.css';

import {
  GOCARDLESS_STATUSES_FOR_BOOKING_TRACKER,
  gcStatusForBookingTrackerFromHumanReadable,
  humanReadableGCMandateStatus
} from 'ducks/tenancy';

interface GocardlessItemProps {
  active: boolean;
  title: string;
  status: string;
  name: string;
  email: string;
  createdAt: string;
  url: string;
  removeItem: () => void;
  openDetailModal?: () => void;
  openGoCardlessItemUrlLink: (event, url) => void;
}

const GocardlessItem: React.SFC<GocardlessItemProps> = ({
  active,
  title,
  status,
  name,
  email,
  createdAt,
  url,
  removeItem,
  openDetailModal,
  openGoCardlessItemUrlLink
}) => {
  const invitationStatusObj =
    GOCARDLESS_STATUSES_FOR_BOOKING_TRACKER[status] ||
    GOCARDLESS_STATUSES_FOR_BOOKING_TRACKER[
      gcStatusForBookingTrackerFromHumanReadable(status)[0]
    ];
  const invitationStatusColor =
    invitationStatusObj && invitationStatusObj.color;

  return (
    <div className={classNames('GocardlessItem', {active})}>
      <div className="header colab-row-space-between">
        <div
          className={classNames('title', {'colab-clickable': openDetailModal})}
          onClick={openDetailModal}>
          {title}
        </div>
        <div className="colab-clickable">
          <div onClick={removeItem}>
            <img
              src={removeButton}
              alt={`Remove GoCardless ${title} from booking`}
            />
          </div>
        </div>
      </div>
      <div className="status">
        {/* TODO: choose proper color */}
        <StatusBox
          status={humanReadableGCMandateStatus(status) || status}
          color={invitationStatusColor}
        />
      </div>
      <div className="body">
        <div className="name">{name}</div>
        <div className="email">{email}</div>
        <div className="createdAt">Created {createdAt}</div>
        <div className="inviteUrl">
          {title} URL link{' '}
          <span onClick={event => openGoCardlessItemUrlLink(event, url)}>
            <ExternalLink href={url} targetBlank>
              <img src={inviteButton} alt={`Open GoCardless ${title}`} />
            </ExternalLink>
          </span>
        </div>
      </div>
    </div>
  );
};

export default GocardlessItem;
